import React, { VFC } from 'react';

import Modal from 'react-bootstrap/Modal';
import CloseBtn from '@/assets/img/close-btn.svg';
import { Button } from '@/components/Elements';

const ExitDialog: VFC<{
  message: string;
  open: boolean;
  onConfirm: () => void;
  onClose: () => void;
}> = ({ open, onConfirm, onClose, message }) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <>
      <Modal show={open} className="show-center">
        {/* <div className='close-modal'>
            <img src={CloseBtn} className="close-btn" />
          </div> */}
        <div className="error-message-title">Unsaved changes</div>
        <div className="error-message">{message}</div>
        <div className="footer-btn-ui">
          <Button type="button"
          className="btn-style-new-ui exit-button-light" onClick={handleConfirm}>
            Discard
          </Button>
          <Button type="button"
          className="btn-style-new-ui " onClick={() => onClose()}>
            Continue editing
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ExitDialog;
